<template>
  <section class="custom-wrapper">
    <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
    <!-- Each tab is a v-if, so switching away mid-import would unmount the progress monitor and lose it. -->
    <div v-if="isBusy" class="row">
      <div class="col">
        <span class="custom-locked">An import is running on this tab. Tabs are locked until it finishes.</span>
      </div>
    </div>
    <div v-if="currentTab === 'Keywords'" class="row">
      <matrix-import-keywords @busy="setBusy" />
    </div>
    <div v-if="currentTab === 'Links'" class="row">
      <matrix-import-links @busy="setBusy" />
    </div>
    <div v-if="currentTab === 'Others'" class="row">
      <matrix-import-others @busy="setBusy" />
    </div>
  </section>
</template>
<script>
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import MatrixImportKeywords from './matrix-import-keywords.vue'
import MatrixImportLinks from './matrix-import-links.vue'
import MatrixImportOthers from './matrix-import-others.vue'
export default {
  name: 'MatrixImportHost',
  components: {
    ZTabs,
    MatrixImportKeywords,
    MatrixImportLinks,
    MatrixImportOthers
  },
  data() {
    return {
      currentTab: 'Keywords',
      tabs: ['Keywords', 'Links', 'Others'],
      isBusy: false
    }
  },
  methods: {
    showTab(tab) {
      // Refuse the switch while an import is in flight on the current tab.
      if (this.isBusy) return
      this.currentTab = tab
    },
    setBusy(busy) {
      this.isBusy = busy
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  height: auto;
}
.custom-locked {
  display: inline-block;
  margin: 10px 15px 0;
  font-size: 0.85em;
  font-weight: 500;
  color: rgb(151, 0, 0);
}
</style>
